import ls from '@/util/ls';

export const setLastCategorySelected = (projectId, categoryId) => {
	if (!ls.get('useLastCategoryUsed', false) || !categoryId) {
		return;
	}
	
	const lastCategoriesSelected = ls.get('lastCategoriesSelected', {});
	lastCategoriesSelected[projectId] = categoryId;
	ls.set('lastCategoriesSelected', lastCategoriesSelected);
};

export const getLastCategorySelected = (projectId) => {
	if (!ls.get('useLastCategoryUsed', false)) {
		return;
	}
	
	const lastCategoriesSelected = ls.get('lastCategoriesSelected', {});
	
	return lastCategoriesSelected[projectId] || null;
};
